import React from 'react';
import CampaignProgressBar from './CampaignProgressBar';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useLogUserActionMutation } from '../../../api/packSlice';

function PacksBox({ packsSummary }) {
    const navigate = useNavigate();
    const [logUserAction] = useLogUserActionMutation();
    const handleClick = () => {
        logUserAction({
            action: 'entry_into_packs_from_landing_page',
            data: { reviewerId: packsSummary.reviewer_id }
        });
        navigate(`/physician/${packsSummary.reviewer_id}/packs`);
    }
    return (
        <Stack p={2} spacing={1} sx={{ borderRadius: '4px', backgroundColor: 'white', boxShadow: 7 }} onClick={handleClick} className='pendo-pack-optimization-summary'>
            <Stack direction='row' spacing={0.5} alignItems='center'>
                <Typography variant='heavy' sx={{ fontSize: '18px' }}>Surgical Pack Review</Typography>
            </Stack>
            <Typography variant='normal' sx={{ fontSize: '14px' }}>Packs - {packsSummary.packs_submitted_count} of {packsSummary.packs_total_count} Reviewed</Typography>
            <CampaignProgressBar
                isReviewed={true}
                num_steps={packsSummary.packs_total_count}
                current_step={packsSummary.packs_submitted_count}
            />
        </Stack>
    );
}

export default PacksBox;